import { THEMES_SET_LOADING_STATE } from 'store/themes';

export function setStatus(status) {
  return { type: THEMES_SET_LOADING_STATE, payload: { status } };
}
